<template>
  <div>
  <v-card class="mt-2">
    <v-card-title>Products Configuration</v-card-title>
    <v-card-text>
      <v-data-table
        v-model="vmd_selected_products"
        :headers="headers"
        :items="loaded_products"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        :single-select="singleSelect"
        item-key="product_id"
        :search="selectFor"
        show-select
        show-expand
        class="elevation-1"
        :items-per-page="loaded_products.length"
        dense
        no-data-text="Load Products from filter"
        :hide-default-footer="!!!loaded_products.length"
        @item-expanded="loadItem"
      >
        <!-- :loading="!loaded_products.length" -->
        <!-- :loading="$store.state.competitorsModule.loading && products.length < 1"
      loading-text="Loading... Please wait" -->

        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="red darken-4" :to="{ name: 'new-product' }">
              <v-icon>add</v-icon>ADD new product
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>Products</v-toolbar-title>
            <v-divider vertical class="mx-5" />
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-4"
              @click="link_Dialog = true"
              class="me-10"
            >
              <v-icon>share</v-icon>LINK
            </v-btn>
            <!-- <v-toolbar-title>Clients: {{ clients.join(" , ") }}</v-toolbar-title> -->
            <!-- <v-spacer></v-spacer> -->

            <v-text-field
              label="Search"
              v-model="selectFor"
              class="pa-3"
              append-icon="mdi-magnify"
              single-line
              style="width: 40px"
            />
            <!-- <v-switch
            v-model="singleSelect"
            label="Single select"
            class="pa-3"
          ></v-switch> -->
          <v-switch
            v-model="singleExpand"
            label="Single expand"
            class="mt-2"
            disabled
          ></v-switch>
          </v-toolbar>
        </template>
        <!-- <template v-slot:item.url="{ item }">
        <div class="domain_row_header_url">
          <v-btn
            @click.native.stop="copyLink"
            fab
            dark
            x-small
            title="Copy the link"
            class="mr-2"
            color="secondary"
          >
            <v-icon>content_copy</v-icon>
          </v-btn>
          <span
            class="link_text d-inline-block text-truncate"
            style="max-width: 900px"
            @click="openUrl_dialog(item)"
          >
            {{ decodeURI(item.url) }}
          </span>
        </div>
      </template> -->
        <!-- <span class="d-inline-block text-truncate" style="max-width: 1000px;"> -->
        <!-- <template v-slot:item.actions="{ item }">
          <div class="d-flex flex-row">
            <v-btn light class="mx-1" color="red darken-4"
              >Link
              <v-icon>share</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.title="{ item }">
          <a :href="item.url" target="_blank" rel="noopener noreferrer">{{
            item.title
          }}</a>
        </template> -->
        <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div class="red darken-2 text-center">
            <ProductDetailsTable
              :size_of_table="5"
            />
          </div>
        </td>
      </template>
      </v-data-table>
    </v-card-text>
  </v-card>
  <v-dialog max-width="1000" v-model="link_Dialog">
      <MassiveLink
        :product_ids="vmd_selected_products.map(p => p.product_id)"
        @exit_link="link_Dialog = false"
        @success_linking="after_linking"
      />
  </v-dialog>
  </div>
</template>

<script>
/* eslint-disable*/
import MassiveLink from "@/components/production/N_MassiveLink.vue";
import ProductDetailsTable from "@/components/production/N_ProductDetailsTable2.vue";

export default {
  name: "n_products_configuration",
  components: {
    MassiveLink,
    ProductDetailsTable,
    },
  data() {
    return {
      selectFor: "",
      vmd_selected_products: [],
      singleExpand: true,
      expanded: [],
      singleSelect: false,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "product_id",
        },
        {
          text: "Brand",
          value: "product_brand.name",
        },
        {
          text: "Name",
          value: "product_name",
        },
        { text: "Clients", value: "clients" },
        { text: "Created", value: "created_at" },
      ],
      link_Dialog: false,
    };
  },
  computed: {
    loaded_products() {
      return this.$store.state.productionModule.loaded_products.filter(
        (p, i) => i < 100
      );
    },
  },
  methods: {
    after_linking() {/* reload product */},
    loadItem({item}) {
      console.log('expanded item', item)
      this.$emit('loadProduct', item.product_id)
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/production/N_ProductsConfiguration.vue